import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';

const stickybits = require('../../vendor/stickybits');

export interface ISticky {
  scrollEl: string;
}

@Directive({
  selector: '[sticky]',
})
export class StickyDirective implements OnInit, OnChanges, OnDestroy {
  @Input() sticky: any;

  private _stickyBitsInstance: any;

  constructor(private _elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.sticky) {
      this.cleanup();

      if (this.sticky) {
        this._stickyBitsInstance = stickybits(this._elementRef.nativeElement, {
          scrollEl: this.sticky.scrollEl,
        });
      }
    }
  }

  ngOnInit() {}

  cleanup() {
    if (this._stickyBitsInstance) {
      this._stickyBitsInstance.cleanup();
    }
  }

  ngOnDestroy() {
    this.cleanup();
  }
}
